export default __webpack_public_path__ + "static/media/os3.6e1bd315.jpeg";